
export async function getData(url: string) {
    const token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');

    try {
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: { "RequestVerificationToken": token },
            }
        );
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        alert("An error has occurred, please refresh the page and try again.");
        console.log(error);
    }
}